<div class="make-a-payment-dd-container" [ngClass]="{ 'not-in-view vm-container cozy': !isDDBarInView }">
  <div class="make-a-payment-dd-bar">
    <div class="dd-bar-copy">
      <h5 class="dd-bar-heading">{{ data?.title }}</h5>
      <div class="how-to-pay-content" [innerHtml]="data?.copy | markdown"></div>
    </div>
  </div>
</div>
